export default {
  auth: {
    instance: 'https://login.microsoftonline.com/organizations',
    clientId: process.env.AUTH_AD_SSO_CLIENT_ID,
    scopes: ['openid', 'profile', 'email', 'User.Read'],
    redirectUri: '/login/callback/aad',
    navigateToLoginRequestUrl: false
  }
};
